module.exports = __webpack_public_path__ + "static/media/image_23.021d5d32.png";